module.exports = __webpack_public_path__ + "img/28.ac551882.jpg";